import {
  PUT_REDUX_USER_DETAILS,
} from '../../reducers/constants';

const putReduxUserDetails = (userDetails) => ({
  type: PUT_REDUX_USER_DETAILS,
  userDetails,
});
export default putReduxUserDetails;
